<template>
  <div class="comContent">
    <searchForm v-model="searchData" @getList="getList(1)" :labelList="searchLabelList" :searchData="searchData"
      @reset="resetForm" :showExport="false" :isShowAddress="true"></searchForm>

    <myTable :index="index" :selection="false" :page="page" :showpage="true" :operation="false" :table-data="tableData"
      :table-option.sync="tableOption" @page-change="getList" :expand="false">
      <template slot="shopBusinessStatus" slot-scope="scope">
        <span style="color: #67c23a" v-if="scope.row.shopBusinessStatus == 0"><i class="el-icon-success"></i> 启用</span>
        <span style="color: #f56c6c" v-if="scope.row.shopBusinessStatus == 2"><i class="el-icon-success"></i> 关店</span>
        <span style="color: #e6a23c" v-if="scope.row.shopBusinessStatus == 1"><i class="el-icon-error"></i> 冻结</span>
      </template>
      <template slot="aptitudeStatus" slot-scope="scope">
        <span style="color: #67c23a" v-if="scope.row.aptitudeStatus == 0"><i class="el-icon-success"></i> 正常</span>
        <span style="color: #e6a23c" v-if="scope.row.aptitudeStatus == 1"><i class="el-icon-warning"></i> 过期</span>
      </template>
      <template slot="status" slot-scope="scope">
        <div style="margin: 0 0px">
          <span style="color:#67C23A" v-if="scope.row.status == 2"><i class="el-icon-success"></i> 通过</span>
          <span style="color:#67C23A" v-if="scope.row.status == 20"><i class="el-icon-success"></i> 一审通过</span>
          <!-- <span style="color:#E6A23C" v-if="shopBusinessStatus == 1"><i class="el-icon-success"></i> 启用</span> -->
          <span style="color:#F56C6C" v-if="scope.row.status == 1"><i class="el-icon-success"></i> 未通过</span>
          <span style="color:#E6A23C" v-if="scope.row.status == 0"><i class="el-icon-error"></i> 待审核</span>
        </div>
      </template>
      <template slot="salesInfo" slot-scope="scope">
        <div v-if="scope.row.salesJobNumber">
          <p>业务员ID：{{ scope.row.salesJobNumber }}</p>
          <p>联系方式：{{ scope.row.contactInformation }}</p>
          <p>业务员名称：{{ scope.row.salesUserName }}</p>
        </div>
      </template>
      <template slot="operation" slot-scope="scope" v-if="scope.row.shopBusinessStatus != 2">
        <div class="linkView">
          <el-link type="primary" :underline="false" style="margin-right: 6px" @click="handleRelate(scope.$index)">
            关联业务员
          </el-link>
          <el-link type="primary" :underline="false" @click="updateStatus(scope.row, 2, '关店')" style="margin-right: 10px">
            关店
          </el-link>
          <el-link type="primary" :underline="false" @click="setAdminAccount(scope.row)" style="margin-right: 10px"
            v-if="scope.row.shopBusinessStatus == 0">
            设置管理账号
          </el-link>
          <el-link type="primary" :underline="false" @click="yuEGuanLi(scope.row)" style="margin-right: 10px">
            余额管理
          </el-link>
        </div>
      </template>
    </myTable>
    <el-dialog title="设置管理账号" :visible.sync="dialogVisible" width="400px">
      <el-form label-width="100px">
        <el-form-item label="原管理账号">
          <el-input v-model="form.account" size="small" :disabled="true" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="现管理账号">
          <el-select v-model="form.userId" value-key="" size="small" style="width: 200px" filterable remote
            reserve-keyword placeholder="请输入关键词" :remote-method="remoteMethod" :loading="searchLoading">
            <el-option v-for="item in adminAccountList" :key="item.userId" :label="item.username" :value="item.userId">
              <span style="float: left">{{ item.fullName }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{
                item.username
              }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="confirmAdmin">确认</el-button>
      </span>
    </el-dialog>

    <SelectSalesman ref="refSelectSalesman" @update="handleUpdate" />
  </div>
</template>
<script>
import searchForm from "../component/searchForm.vue";
import myTable from "@/components/myTable";
import _ from "lodash";
import {
  getClientPage,
  getClientPageNew,
  getListByType,
  updateClientStatus,
  getUserListByPhone,
  changeShopUserAdmin,
} from "@/api/businessManage";

import SelectSalesman from "@/views/salesControl/OperationsManag/dialog/SelectSalesman.vue";

export default {
  components: { searchForm, myTable, SelectSalesman },
  props: {},
  data () {
    return {
      form: {
        account: "",
        shopId: "",
        newAccount: "",
        userId: "",
      },
      adminAccountList: [],
      dialogVisible: false, //可选择设置的管理员账号
      searchLoading: false,
      operation: false,
      selection: true,
      index: false,
      page: {
        total: 11,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      tableData: [],
      tableOption: [
        // { label: "订单创建时间", prop: "orderTime", width: 160 },
        { label: "客户ID", prop: "shopCode", width: 160 },
        { label: "客户名称", prop: "shopName", width: 260 },
        { label: "客户类型", prop: "typeName", width: 200 },
        // { label: "登录用户名", prop: "loginUserName", width: 200 },
        { label: "省", prop: "provinceName" },
        { label: "市", prop: "cityName" },
        { label: "区", prop: "areaName", width: 120 },
        { label: "详细地址", prop: "address", width: 120 },
        { label: "资质状态", prop: "aptitudeStatus", width: 120, slot: true },
        {
          label: "启用状态",
          prop: "shopBusinessStatus",
          width: 120,
          slot: true,
        },
        {
          label: "商户状态",
          prop: "status", //商户状态名称(0.待审核，1.未通过，2.通过,20.一审通过)
          width: 120,
          slot: true,
        },
        { label: "业务员信息", prop: "salesInfo", width: 200, slot: true },
        {
          label: "操作",
          prop: "operation",
          slot: true,
          width: 150,
          align: "center",
          // fixed: "right",
        },
        //  {
        //   name: "登录用户名",
        //   fieldName: "loginUserName",
        //   type: "input",
        // },
      ],
      searchData: {
        shopBusinessStatus: "",
        shopTypeCode: "",
        certifyStatus: '',
        status: '2',
      },
      searchLabelList: [
        {
          name: "省",
          fieldName: "province",
          type: "province",
        },
        {
          name: "市",
          fieldName: "city",
          type: "city",
        },
        {
          name: "区",
          fieldName: "area",
          type: "area",
        },
        {
          name: "客户类型",
          fieldName: "shopTypeCode",
          width: 150,
          type: "select",
          disabled: false,
          select: [],
        },
        {
          name: "启用状态",
          width: 150,
          fieldName: "shopBusinessStatus",
          type: "select",
          disabled: false,
          select: [
            {
              name: "启用",
              id: 0,
            },
            // {
            //   name: "冻结",
            //   id: 1,
            // },
            {
              name: "关店",
              id: 2,
            },
          ],
        },
        {
          name: "资质状态",
          width: 150,
          fieldName: "certifyStatus",
          type: "select",
          disabled: false,
          select: [
            {
              name: "正常",
              id: 1,
            },
            {
              name: "过期",
              id: 2,
            },
            {
              name: "临期",
              id: 3,
            },
          ],
        },
        {
          name: "店铺状态",
          width: 150,
          fieldName: "status",
          type: "select",
          disabled: false,
          select: [
            {
              name: "待审核",
              id: '0',
            },
            {
              name: "未通过",
              id: '1',
            },
            {
              name: "通过",
              id: '2',
            },
            {
              name: "一审通过",
              id: '20',
            },
          ],
        },
        {
          name: "客户名称",
          fieldName: "shopName",
          width: 150,
          type: "input",
          disabled: false,
        },
        {
          name: "业务员ID/业务员手机号/业务员姓名",
          fieldName: "nameLike",
          type: "nameLike",
        },
      ],
    };
  },
  filters: {},
  created () { },
  mounted () {
    this.expanded = true
    const { tab, status } = this.$route.query
    this.resetForm()
    if (tab) {
      this.searchData.certifyStatus = Number(tab)
      this.expanded = true
    }
    if (status) {
      this.searchData.status = String(status)
      this.expanded = true
    } else if (!tab) {
      // 首页临期/过期只带 tab（资质状态）时，不默认附加「通过」状态
      this.searchData.status = '2'
    }
    this.getListByType();
    this.getList(1);
  },
  methods: {
    yuEGuanLi (row) {
      this.$router.push({
        path: "/business/businessManage-customer-balance",
        query: {
          shopId: row.id,
          shopName: row.shopName,
        },
      });
    },
    handleUpdate () {
      this.getList(1);
    },
    handleRelate (index) {
      const item = this.tableData[index];
      this.$refs.refSelectSalesman.open2(item);
    },
    remoteMethod: _.throttle(async function (query) {
      // 远程搜索账户
      if (query !== "") {
        this.searchLoading = true;
        try {
          const resp = await getUserListByPhone({ phone: query });
          this.searchLoading = false;
          if (resp) {
            this.adminAccountList = resp;
          } else {
            this.adminAccountList = [];
          }
        } catch (error) {
          this.adminAccountList = [];
          this.searchLoading = false;
        }
      } else {
        this.adminAccountList = [];
      }
    }, 1000),
    setAdminAccount (row) {
      this.form.account = row.loginUserName;
      this.form.shopId = row.id;
      this.dialogVisible = true;
    },
    async confirmAdmin () {
      // 设置管理员账号
      console.log(this.form);
      let obj = {
        shopId: this.form.shopId,
        userId: this.form.userId,
      };
      const resp = await changeShopUserAdmin(obj);
      if (resp) {
        this.dialogVisible = false;
        this.form.userId = "";
        this.$message.success("设置成功");
        this.getList();
      }
    },
    updateStatus (row, status, typeText) {
      let params = {
        id: row.id,
        aptitudeStatus: row.aptitudeStatus,
        whetherClose: true,
      };
      if (status == 1 || status == 2) {
        this.$confirm(`确定要${typeText}【 ${row.shopName}】吗?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.updateClientStatus(params);
          })
          .catch(() => { });
      } else {
        this.updateClientStatus(params);
      }
      // 更新状态 商户业务状态(0：正常；1：冻结；2：注销)
    },

    updateClientStatus (params) {
      updateClientStatus(params).then((res) => {
        if (res.code == 0) {
          this.$message.success("提交成功");
          this.getList(1);
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    // 获取客户类型列表
    getListByType () {
      getListByType({
        type: 0, //0 客户类型  1商户类型
      }).then((res) => {
        console.log(res);
        let selectList = [];
        for (let i = 0; i < res.data.length; i++) {
          selectList.push({
            id: res.data[i].typeCode,
            name: res.data[i].typeName,
          });
        }
        console.log(selectList, "selectList---selectList");
        for (let i = 0; i < this.searchLabelList.length; i++) {
          if (this.searchLabelList[i].fieldName == "shopTypeCode") {
            this.searchLabelList[i].select = selectList;
          }
        }
      });
    },
    getList (current) {
      const params = Object.assign({}, this.searchData);
      if (this.searchData.province) {
        params.provinceName = this.searchData.province;
        delete params.province;
      }
      if (this.searchData.city) {
        params.cityName = this.searchData.city;
        delete params.city;
      }
      if (this.searchData.area) {
        params.areaName = this.searchData.area;
        delete params.area;
      }
      params.size = this.page.size;

      if (current) {
        params.current = 1;
      } else {
        params.current = this.page.current;
      }
      getClientPageNew(params).then((data) => {
        if (data) {
          this.tableData = data.records;
          this.page.total = data.total;
        } else {
          this.tableData = [];
          this.page.total = 0;
        }
      });
    },
    resetForm () {
      this.page.current = 1;
      for (const key in this.searchData) {
        this.searchData[key] = "";
      }
      // this.getList();
    },
    // 查看详情
    checkDetails (row) {
      this.$router.push("./businessManage-shop-detail");
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep.el-table {
  height: calc(100% - 138px) !important;
}

::v-deep.zt__table {
  height: calc(100% - 118px) !important;
}

::v-deep.el-table .el-table__body-wrapper {
  height: calc(100% - 78px) !important;
  overflow-y: scroll !important;
}

.linkView {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .el-link {
    margin: 5px;
  }
}
</style>
